import { mapCheckToPlaybook } from './playbooks/checkMap';
import { loadPlaybookSync } from './playbooks/loadPlaybook';
import { collectManualChecks } from './playbooks/manualChecks';
import type { NextAction } from './nextAction';
import { sortGapsByPriority } from './tui/menu';
import type { CliScanArtifact } from './types';

export function resolveNextAction(artifact: CliScanArtifact): NextAction {
  const repoGap = sortGapsByPriority(artifact.gaps)[0];
  if (repoGap) {
    return {
      type: 'repo-fix',
      title: repoGap.title,
      detail: repoGap.detail,
      command: `viberaven prompt --gap ${repoGap.id}`
    };
  }

  const manual = collectManualChecks(artifact)[0];
  if (manual) {
    const provider = mapCheckToPlaybook(manual.check);
    let openUrl: string | undefined;
    try {
      const playbook = loadPlaybookSync(provider);
      openUrl = playbook.steps[0]?.openUrl;
    } catch {
      openUrl = undefined;
    }
    return {
      type: 'provider-guide',
      title: manual.check.label,
      detail:
        manual.check.promptHint ||
        `Configure ${manual.providerLabel} in the provider dashboard (${manual.areaLabel}).`,
      provider,
      playbookStep: 1,
      command: `viberaven guide ${provider} --step 1`,
      openUrl
    };
  }

  return {
    type: 'done',
    title: 'No blockers found',
    detail: 'Re-scan after changes to confirm production readiness.'
  };
}
